/**
 * @file  src\components\Inventory\CreateInventory\NiceToHave\Layout.js
 * @brief  This file is responsible for nice to have selection in inventory creation
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import NiceToHaveHelper from "./NiceToHaveHelper";

const Layout = (props) => {
  const { layout, handleItemClick, itemArray } = props;
  return (
    <NiceToHaveHelper
      list={layout}
      selectedItems={itemArray}
      propertyClick={handleItemClick}
    />
  );
};
export default Layout;
